module.exports = __webpack_public_path__ + "img/26c5097ccf2542cf967dcad14c35bec2-1440.23d6340c.jpg";